export const Reuse9035 = `
... on Form9035DatahubReuse {
    a1_visa_type

    b1_job_title
    b2_soc_code
    b3_soc_title
    b4_is_full_time
    b5_begin_date
    b6_end_date
    b7_total_positions
    b7a_new_employment
    b7b_continuation
    b7c_change_approved
    b7d_new_concurrent
    b7e_change_employer
    b7f_amended_petition

    c1_emp_name
    c2_emp_dba
    c3_emp_address_1
    c4_emp_address_2
    c5_emp_city
    c6_emp_state_id
    c7_emp_zip
    c8_emp_country_id
    c9_emp_province
    c10_emp_phone
    c11_emp_phone_ext
    c12_emp_fein
    c13_emp_naics
    c13_emp_naics_description

    d1_poc_last
    d2_poc_first
    d3_poc_middle
    d4_poc_title
    d5_poc_address_1
    d6_poc_address_2
    d7_poc_city
    d8_poc_state_id
    d9_poc_zip
    d10_poc_country_id
    d11_poc_province
    d12_poc_phone
    d13_poc_phone_ext
    d14_poc_email

    e1_is_represented
    e2_agent_last
    e3_agent_first
    e4_agent_middle
    e5_agent_address_1
    e6_agent_address_2
    e7_agent_city
    e8_agent_state_id
    e9_agent_zip
    e10_agent_country_id
    e11_agent_province
    e12_agent_phone
    e13_agent_phone_ext
    e14_agent_email
    e15_agent_firm_name
    e16_agent_firm_fein
    e17_agent_bar_number
    e18_agent_court_state_id
    e19_agent_court_name

    g1_read_agree

    h1_is_dependent
    h2_is_willful_violator
    h3_only_h1b
    h4_exemption_basis
    h5_is_appendix_a_completed
    h6_read_agree

    i1_is_disclosure_principal_business
    i1_is_disclosure_place_of_employment

    j1_official_last
    j2_official_first
    j3_official_middle
    j4_official_title
    j6_official_date_signed

    k1_prep_last
    k2_prep_first
    k3_prep_middle
    k4_prep_firm_name
    k5_prep_email
  }
`;
